import { EnvironmentBarDto } from '../generated-types/environmentBarDto';
import { AbstractApi } from './AbstractApi';

/**
 * An api to interact with the setup controller
 */
export default class SetupApi extends AbstractApi {
  /**
   * Get the log rocket app id.
   */
  async GetLogRocketAppId(): Promise<string> {
    const response = await fetch(this.BuildUrl('setup/log-rocket'), {
      method: 'GET',
    });

    if (!response.ok) throw Error();

    return response.text();
  }

  /**
   * Get the environment bar details
   */
  async GetEnvironmentBar(): Promise<EnvironmentBarDto> {
    const response = await fetch(this.BuildUrl('setup/environment-bar'), {
      method: 'GET',
    });

    if (!response.ok) throw Error();

    return (await response.json()) as EnvironmentBarDto;
  }
}
